// ArenaAudioPlatformFactory.ts - Factory to instantiate platform-specific audio adapters
import { IArenaAudioPlatformAdapter } from './IArenaAudioPlatformAdapter';
import { IOSArenaAudioAdapter } from './IOSArenaAudioAdapter';
import { AndroidArenaAudioAdapter } from './AndroidArenaAudioAdapter';
import { StandardArenaAudioAdapter } from './StandardArenaAudioAdapter';
import { isAndroidDevice, isIOSDevice } from '../../../voice/platform/deviceDetection';

export class ArenaAudioPlatformFactory {
  public static createAdapter(): IArenaAudioPlatformAdapter {
    if (isIOSDevice()) {
      return new IOSArenaAudioAdapter();
    }
    if (isAndroidDevice()) {
      return new AndroidArenaAudioAdapter();
    }
    return new StandardArenaAudioAdapter();
  }
}
